import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import * as english from './assets/locales/en.json'
import router from './router'
import store from './store'

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  messages: {
    en: {
      message: english.translation
    }
  }
})

const app = createApp(App)
app.use(i18n).use(store).use(router).mount('#app')
